import { Box, Divider, Grid } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import { supplierSheetSelectedCompanyIdAtom } from '../state';
import SupplierCard, { SupplierCardData } from '../company/common/SupplierCard';
import { DisplayMode } from '../search/state/state';
import WishlistContactButton from './WishlistContactButton';
import WishlistSupplierRow from './WishlistSupplierRow';
import { wishlistDisplayModeAtom } from './state';

interface WishlistSupplierListProps {
  suppliers: SupplierCardData[];
}

export default function WishlistSupplierList({ suppliers }: WishlistSupplierListProps): React.JSX.Element {
  const displayMode = useAtomValue(wishlistDisplayModeAtom);
  const setSelectedCompanyId = useSetAtom(supplierSheetSelectedCompanyIdAtom);

  if (displayMode === DisplayMode.LIST) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          width: '100%',
          '& .MuiDivider-root:not(:last-child)': {
            display: 'block',
          },
          '& .MuiDivider-root:last-child': {
            display: 'none',
          },
        }}
      >
        {suppliers.map((supplier) => (
          <>
            <WishlistSupplierRow supplier={supplier} key={supplier.id} />
            <Divider />
          </>
        ))}
      </Box>
    );
  }

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      {suppliers.map((supplier) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2.4 }} key={supplier.id}>
          <SupplierCard
            displayWishlistButton
            supplier={supplier}
            onSupplierClick={() => setSelectedCompanyId(supplier.id)}
            actionButton={<WishlistContactButton supplierId={supplier.id} />}
          />
        </Grid>
      ))}
    </Grid>
  );
}
